<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','panels')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create panel') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <panels-list
      v-else
      :fields="fields"
      :items="items"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import PanelsList from '../../../components/admin/panels/list/PanelsList'

export default {
  components: {
    PanelsList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'panels',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
        },
        {
          key: 'name',
          label: this.$t('Name'),
        },
        {
          key: 'price',
          label: this.$t('Price'),
        },
        {
          key: 'number_of_accounts',
          label: this.$t('Number of accounts'),
        },
        {
          key: 'webhook',
          label: this.$t('Webhook'),
        },
        {
          key: 'messages_count',
          label: this.$t('Messages count'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
